import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { PaymentsService } from '../../services/payments.service';

@Component({
	selector: 'app-pending-payment-runs',
	templateUrl: './pending-payment-runs.component.html',
	styleUrls: ['./pending-payment-runs.component.scss']
})
export class PendingPaymentRunsComponent implements OnInit {
	runs: any[] = [];
	loading = true;
	color = 'blue';

	constructor(
		private router: Router,
		private globalSearchService: GlobalSearchService,
		private paymentsService: PaymentsService
	) {
		this.color = this.globalSearchService.getColor();
	}

	ngOnInit(): void {
		this.loadRuns();
	}

	loadRuns(): void {
		this.loading = true;
		this.paymentsService.getPendingRuns().subscribe(
			(res: any) => {
				this.loading = false;
				if (res.success && Array.isArray(res.runs)) {
					this.runs = res.runs;
				} else {
					this.runs = [];
				}
			},
			() => {
				this.loading = false;
				this.runs = [];
			}
		);
	}

	openRun(run: any): void {
		this.router.navigate(['/vendors-check-print', run.journalno]);
	}

	discardRun(run: any, event: Event): void {
		event.stopPropagation();
		if (!confirm(`Discard payment run #${run.journalno}? This cannot be undone.`)) {
			return;
		}
		this.paymentsService.discardRun({ journal: run.journalno }).subscribe(
			(res: any) => {
				if (res.success) {
					this.globalSearchService.showNotification('Run discarded.', 'success', 'bottom', 'right');
					this.loadRuns();
				} else {
					alert(res.error || 'Failed to discard.');
				}
			},
			(err: any) => {
				alert(err?.error?.error || 'Failed to discard.');
			}
		);
	}

	formatDate(val: string | null): string {
		if (!val) return '';
		const d = new Date(val);
		return isNaN(d.getTime()) ? val : d.toLocaleDateString() + ' ' + d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
	}

	back(): void {
		this.router.navigate(['/vendors-check-print']);
	}
}
